<template>
  <div class="totalshare" :style="{ '--source-color': `var(--${color}-main)` }">
    <div class="totalshare__title">Share on Total World - %</div>
    <div class="totalshare__content">
      <template v-for="(item, index) in totalShare">
        <Bar :data="item" :key="index"></Bar>
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Bar from "@/components/widgets/Bar.vue";

export default {
  name: "TotalShare",
  components: {
    Bar,
  },
  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      color: "ui/sourceColor",
      totalShare: "data/getTotalShare",
    }),
  },
};
</script>

<style lang="scss" scoped>
.totalshare {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3.5vh 2.7vw 3.5vh 2.7vw;
  padding-top: 3.5vh;
  border: $white-border;
  border-left: none;

  &__title {
    @include title-H6;
    color: $ui-white;
    align-self: flex-start;
    margin-bottom: 2.5vh;
  }

  &__content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    height: 100%;
    width: 100%;
  }
}

.mobile {
  .totalshare {
    height: 46.9vh;
    padding: 0;
    &__title {
      margin-bottom: 0;
      padding: 4.5vh 0 0 16.8vw;
    }
    &__content {
      padding: 0 24.27vw 4vh 16.84vw;
    }
  }
}

.tablet {
  .totalshare {
    height: 100%;
    width: 100%;
    padding: 0;
    border: none;
    &__title {
      margin-bottom: 0;
      padding: 1.66vh 0 1vh 5.86vw;
    }
    &__content {
      padding: 0 9.7vw 1vh 11.72vw;
    }
  }
}
</style>
